import WonderType from "@/roc/wonders/base/WonderType";
import WonderKind from "@/roc/wonders/base/WonderKind";
import WonderOwner from "@/roc/wonders/base/WonderOwner";
import Effects from '@/roc/effects/Effects';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import Synergy from '@/roc/wonders/base/Synergy';
import EraType from '@/roc/era/EraType';

const Valhalla = {
  id: '71',
  name: 'Valhalla',
  era: EraType.earlyRome,
  icon: 'valhalla',
  gameId: 'Valhalla',
  minLevel: 1,
  maxLevel: 30,
  type: WonderType.STORIES_AND_MYTHS,
  kind: WonderKind.ARENA,
  kindMultiplier: 1,
  owner: WonderOwner.VIKINGS,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.TOTAL_DAMAGE_MOD,
      EffectAmount.asPerLevel([
        5,
        5.6,
        6.0,
        6.4,
        6.6,  // 5
        6.9,
        7.2,
        7.4,
        7.6,
        7.8, // 10
        7.9,
        8.1,
        8.3,
        8.4,
        8.6, // 15
        8.7,
        8.8,
        9.0,
        9.1,
        9.2, // 20
        9.4,
        9.5,
        9.6,
        9.7,
        9.8, // 25
        9.9,
        10.0,
        10.1,
        10.2,
        10.3 // 30
      ]),
      '%',
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput
        .asFlat(1)
        .withOutput(ProductionOutputType.CHEST)
        .withDescription('Produce chest which can include mercenary commander.')
      ,
    ),
    new PassiveAura(
      PassiveAuraType.EXTRA_COMMANDER_SLOT,
      EffectAmount.asFlat(1),
    ),
  ]),
  synergies: [
    {
      effectIndex: 0,
      mod: Synergy.asFlat(1.5).withKind(WonderKind.PALACE),
      effect: null,
    }
  ],
};

export default Valhalla;
